import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OverlayScrollbars from 'overlayscrollbars';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var ScrollBar =
/*#__PURE__*/
function (_Component) {
  _inherits(ScrollBar, _Component);

  function ScrollBar() {
    _classCallCheck(this, ScrollBar);

    return _possibleConstructorReturn(this, _getPrototypeOf(ScrollBar).apply(this, arguments));
  }

  _createClass(ScrollBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.init();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.scrollBars = null;
    }
  }, {
    key: "init",
    value: function init() {
      var _this$props = this.props,
          className = _this$props.className,
          resize = _this$props.resize,
          sizeAutoCapable = _this$props.sizeAutoCapable,
          clipAlways = _this$props.clipAlways,
          normalizeRTL = _this$props.normalizeRTL,
          paddingAbsolute = _this$props.paddingAbsolute,
          autoUpdate = _this$props.autoUpdate,
          autoUpdateInterval = _this$props.autoUpdateInterval,
          nativeScrollbarsOverlaid = _this$props.nativeScrollbarsOverlaid,
          overflowBehavior = _this$props.overflowBehavior,
          scrollbars = _this$props.scrollbars,
          textarea = _this$props.textarea,
          callbacks = _this$props.callbacks;
      this.scrollBars = OverlayScrollbars(this.ScrollbarRef, {
        className: className,
        resize: resize,
        sizeAutoCapable: sizeAutoCapable,
        clipAlways: clipAlways,
        normalizeRTL: normalizeRTL,
        paddingAbsolute: paddingAbsolute,
        autoUpdate: autoUpdate,
        autoUpdateInterval: autoUpdateInterval,
        nativeScrollbarsOverlaid: nativeScrollbarsOverlaid,
        overflowBehavior: overflowBehavior,
        scrollbars: scrollbars,
        textarea: textarea,
        callbacks: callbacks
      });
    }
  }, {
    key: "getScrollBars",
    value: function getScrollBars(name) {
      var _this$scrollBars;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return (_this$scrollBars = this.scrollBars)[name].apply(_this$scrollBars, args);
    }
  }, {
    key: "options",
    value: function options() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.getScrollBars.apply(this, ['options'].concat(args));
    }
  }, {
    key: "update",
    value: function update() {
      this.getScrollBars('update');
    }
  }, {
    key: "sleep",
    value: function sleep() {
      this.getScrollBars('sleep');
    }
  }, {
    key: "scroll",
    value: function scroll() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.getScrollBars.apply(this, ['scroll'].concat(args));
    }
  }, {
    key: "scrollStop",
    value: function scrollStop() {
      this.getScrollBars('scrollStop');
    }
  }, {
    key: "getElements",
    value: function getElements() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.getScrollBars.apply(this, ['getElements'].concat(args));
    }
  }, {
    key: "getState",
    value: function getState() {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return this.getScrollBars.apply(this, ['getState'].concat(args));
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.getScrollBars('destroy');
    }
  }, {
    key: "ext",
    value: function ext() {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return this.getScrollBars.apply(this, ['ext'].concat(args));
    }
  }, {
    key: "addExt",
    value: function addExt() {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return this.getScrollBars.apply(this, ['addExt'].concat(args));
    }
  }, {
    key: "removeExt",
    value: function removeExt() {
      for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        args[_key8] = arguments[_key8];
      }

      this.getScrollBars.apply(this, ['removeExt'].concat(args));
    }
  }, {
    key: "defaultOptions",
    value: function defaultOptions() {
      return OverlayScrollbars.defaultOptions();
    }
  }, {
    key: "globals",
    value: function globals() {
      return OverlayScrollbars.globals();
    }
  }, {
    key: "extension",
    value: function extension() {
      return OverlayScrollbars.extension.apply(OverlayScrollbars, arguments);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return React.createElement("div", {
        id: this.props.id,
        ref: function ref(el) {
          return _this.ScrollbarRef = el;
        },
        style: _objectSpread2({}, this.props.style)
      }, this.props.children);
    }
  }]);

  return ScrollBar;
}(Component);

ScrollBar.propTypes = {
  id: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  resize: PropTypes.oneOf(['none', 'both', 'horizontal', 'vertical', 'n', 'b', 'h', 'v']),
  sizeAutoCapable: PropTypes.bool,
  clipAlways: PropTypes.bool,
  normalizeRTL: PropTypes.bool,
  paddingAbsolute: PropTypes.bool,
  autoUpdate: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  autoUpdateInterval: PropTypes.number,
  nativeScrollbarsOverlaid: PropTypes.object,
  overflowBehavior: PropTypes.object,
  scrollbars: PropTypes.object,
  textarea: PropTypes.object,
  callbacks: PropTypes.object
};
ScrollBar.defaultProps = {
  id: '',
  style: {},
  className: 'os-theme-dark',
  resize: 'none',
  sizeAutoCapable: true,
  clipAlways: true,
  normalizeRTL: true,
  paddingAbsolute: false,
  autoUpdate: null,
  autoUpdateInterval: 33,
  nativeScrollbarsOverlaid: {
    showNativeScrollbars: false,
    initialize: true
  },
  overflowBehavior: {
    x: 'scroll',
    y: 'scroll'
  },
  scrollbars: {
    visibility: 'auto',
    autoHide: 'never',
    autoHideDelay: 800,
    dragScrolling: true,
    clickScrolling: false,
    touchSupport: true
  },
  textarea: {
    dynWidth: false,
    dynHeight: false,
    inheritedAttrs: ['style', 'class']
  },
  callbacks: {
    onInitialized: null,
    onInitializationWithdrawn: null,
    onDestroyed: null,
    onScrollStart: null,
    onScroll: null,
    onScrollStop: null,
    onOverflowChanged: null,
    onOverflowAmountChanged: null,
    onDirectionChanged: null,
    onContentSizeChanged: null,
    onHostSizeChanged: null,
    onUpdated: null
  }
};

export default ScrollBar;
